import React, { Component } from 'react';

import LeadsListWithFilteredData from './LeadsListWithFilteredData';
import LeadsFilter from '../LeadsFilter/LeadsFilter';

export default class LeadsPage extends Component{

  constructor(props) {
    super(props);

    this.state = {
      filter_data: null,
    };

    this.onFilterChange = this.onFilterChange.bind(this);
  }


  componentWillMount(){

    const {app_data, history} = this.props;

    const role = app_data.roles[app_data.user.role_id];

    if(!role.access.leads) {
      history.push(role.default_page);
    }

  }

  onFilterChange(data) {
    this.setState({
      filter_data: data
    });
  }

  onFilterInit() {

  }

  render() {

    const {app_data, history} = this.props;

    const {filter_data} = this.state;



    return (
      <div className={`container`}>

        <h1>Обращения</h1>

        <LeadsFilter
          app_data={app_data}
          onFilterChange={this.onFilterChange}
        />

        {filter_data &&
          <LeadsListWithFilteredData app_data={app_data} filter_data={filter_data} />
        }



      </div>
    );
  }
}

